import '../../resources/less/common.css';
import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';

export function LocationConfirmEditor({title, region, cancelRegion, setRegion}) {

    const confirmRegion = (e) => {
        e.preventDefault();
        setRegion(region);
    };

    return (
        <Modal id="region-confirmation-modal"
            show={true}
            animation={false}
            backdrop='static'
            onHide={cancelRegion}
            className={classnames('modal-overflow')}>

            <Modal.Header closeButton>
                <h1 className="tw-font-bold tw-font-body tw-text-16px" data-testid="header-title">{title}</h1>
            </Modal.Header>
            <Modal.Body>
                <div id="location-confirm-container" className="tw-mt-28px tw-mb-24px tw-font-body tw-text-med">
                    <p id="location-confirm-text" data-testid="location-confirm-text">
                        Your Data Infrastructure Insights tenant will be created in the <strong>{region.description}</strong> region using <strong>{region.cloudDisplayName}</strong> cloud provider.
                        You will not be able to change the region or cloud provider once the tenant is created.
                    </p>
                    <p id="location-confirm-region-text" className="tw-pt-18px" data-testid="location-confirm-region-text">
                        Click <strong>Create</strong> to confirm your tenant.
                    </p>
                </div>
            </Modal.Body>
            <Modal.Footer className="tw-bg-gray-100 tw-pt-8px tw-pb-8px">
                <Button id="location-confirm-no" data-testid="confirm-no" variant="secondary"
                    className="tw-border-gray-250 tw-text-black hover:tw-text-black hover:tw-bg-gray-200 tw-font-body tw-text-med"
                    onClick={cancelRegion}>
                    Cancel
                </Button>
                <Button id="location-confirm-yes" data-testid="confirm-yes" variant="primary"
                    className="tw-bg-netapp-blue tw-border-gray-250 hover:tw-bg-netapp-blue hover:tw-text-white tw-text-white tw-font-body tw-text-med"
                    onClick={confirmRegion}>
                    Create
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

LocationConfirmEditor.displayName = 'LocationConfirmEditor';
LocationConfirmEditor.propTypes = {
    title: PropTypes.string,
    region: PropTypes.object.isRequired,
    cancelRegion: PropTypes.func.isRequired,
    setRegion: PropTypes.func.isRequired,
};

export default LocationConfirmEditor;
